import create from "zustand"

const refsStore = create(set => ({
  provincias: [],
  actividad: [],
  personeria: [],
  referidos: [],
  condicionIva: [],
  asesorComercial: [],
  actividadEspecifica: [],
  situacionBCRA: [],
  tamanioEmpresa: [],
  tipoCanalComercializacion: [],
  sectorEconomico: [],
  originador: [],
  relacionSocio: [],
  setProvincias: provincias => set({ provincias }),
  setActividad: actividad => set({ actividad }),
  setPersoneria: personeria => set({ personeria }),
  setReferidos: referidos => set({ referidos }),
  setCondicionIva: condicionIva => set({ condicionIva }),
  setAsesorComercial: asesorComercial => set({ asesorComercial }),
  setActividadEspecifica: actividadEspecifica => set({ actividadEspecifica }),
  setSituacionBCRA: situacionBCRA => set({ situacionBCRA }),
  setTamanioEmpresa: tamanioEmpresa => set({ tamanioEmpresa }),
  setTipoCanalComercializacion: tipoCanalComercializacion =>
    set({ tipoCanalComercializacion }),
  setSectorEconomico: sectorEconomico => set({ sectorEconomico }),
  setOriginador: originador => set({ originador }),
  setRelacionSocio: relacionSocio => set({ relacionSocio }),
}))

export default refsStore
